import React, { PureComponent } from 'react';

import iconSearch from './assets/search.svg';
import iconClose from './assets/close.svg';

import config from './SearchBox.component.config';
import './SearchBox.less';

class SearchBox extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
    };
  }

  _onChange = event => {
    this.setState({
      value: event.target.value.length || 0,
    });
    this.props.onChange(event);
  };

  _onClose = event => {
    const modify = { ...event };
    document.getElementById('search-box').value = '';
    modify.target.value = '';
    this.setState({
      value: 0,
    });
    this.props.onChange(modify);
  };

  render() {
    const { value } = this.state;
    return (
      <div className="search-box">
        <div className="search-icon">
          <img src={iconSearch} alt="search-icon" />
        </div>
        <div className="search-input">
          <input
            id="search-box"
            type="text"
            placeholder={this.props.placeholder}
            onChange={this._onChange}
          />
          <div
            className={`close-btn ${value > 0 ? 'active' : ''} `}
            onClick={this._onClose}
          >
            <img src={iconClose} alt="close-img" />
          </div>
        </div>
      </div>
    );
  }
}

SearchBox.displayName = config.displayName;
SearchBox.propTypes = config.propTypes;
SearchBox.defaultProps = config.defaultProps;

export default SearchBox;
